import React, { ReactNode } from 'react'
import { RequestState } from "../../modules/types"
import Loading from '../Loading'

type Props = {
  requestState: RequestState
  children: ReactNode
  errorText: string
}

function RequestStateContainer(props: Props) {
  const { requestState, children, errorText } = props

  switch (requestState) {
    case RequestState.Loading: {
      return (
        <Loading />
      )
    }

    case RequestState.Loaded: {
      return (
        <div>
        {children}
        </div>
      )
    }

    case RequestState.Error: {
      return (
        <div className="panel-loading">
          {errorText}
        </div>
      )
    }    

    default: {
      return <div/>
    }
  }
}

export default RequestStateContainer
